export const searchParamKeys = {
  page: 'page'
};
